import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Hero from '@/components/Hero';
import PhotoGallery from '@/components/PhotoGallery';
import { Camera, Users, Image, Youtube } from 'lucide-react';

const Gallery = () => {
  const [imagesLoading, setImagesLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setImagesLoading(false);
    }, 2000);
    
    return () => clearTimeout(timer);
  }, []);

  // Gallery items - tour photos
  const galleryImages = [
    // Adding the user's new uploaded tour photos
    { id: 40, src: '/lovable-uploads/618bc585-495c-4ede-9210-d4a1a82cc8f7.png', alt: 'Tour group walking through New York City streets' },
    { id: 41, src: '/lovable-uploads/3a41ff29-c567-41dc-b249-03edc4cf969b.png', alt: 'Tour guide presenting to group near a fountain' },
    { id: 42, src: '/lovable-uploads/b214ecfe-1bc9-4aff-89bc-db69fe6f5a13.png', alt: 'Tour guide sharing stories in a park' },
    { id: 43, src: '/lovable-uploads/1cde2dda-2543-47e0-8992-056e47304552.png', alt: 'Tour group walking through a leafy park' },
    { id: 44, src: '/lovable-uploads/d95e56cc-f6f5-4a7b-b18f-33e7f8c5bdc4.png', alt: 'Cat tour walking through trees in NYC' },
    { id: 45, src: '/lovable-uploads/0390c64c-61a9-4a20-8c0a-ad3de146e1c9.png', alt: 'Tour guide with blue flag in a park' },
    { id: 46, src: '/lovable-uploads/6a515d6f-4107-4e83-a757-1b74a2f75b64.png', alt: 'Tour guide with tour group next to a historic clock' },
    { id: 47, src: '/lovable-uploads/feecf7cf-d050-430e-8108-d593ce0651ac.png', alt: 'Tour guide with blue flag near historic building on White St' },
    
    // Previous gallery images
    { id: 30, src: '/lovable-uploads/e100a577-5b2e-45e7-8c5a-045a615b98ba.png', alt: 'Tour guide explaining cat history to group in Brooklyn Heights' },
    { id: 31, src: '/lovable-uploads/cf69d03b-6e71-43d3-936d-5465eaa5212f.png', alt: 'Tour group crossing street in Brooklyn' },
    { id: 32, src: '/lovable-uploads/1553a72d-81c5-4494-b76b-3644eac47893.png', alt: 'Tour guide sharing stories with attentive group' },
    
    // Original gallery images
    { id:  1, src: '/lovable-uploads/catsabouttowntours_1724332571_3440273418833225241_67182239447.jpg', alt: 'Cats About Town Tours - NYC Cat History' },
    { id:  2, src: '/lovable-uploads/catsabouttowntours_1738852061_3562071727192517822_67182239447.jpg', alt: 'Cat-themed historical tour in New York City' },
    { id:  3, src: '/lovable-uploads/catsabouttowntours_1738852061_3562071727167250228_67182239447.jpg', alt: 'NYC feline history tour' },
    { id:  4, src: '/lovable-uploads/catsabouttowntours_1738852061_3562071727175756036_67182239447.jpg', alt: 'Cat history walking tour' },
    { id:  5, src: '/lovable-uploads/catsabouttowntours_1738852061_3562071727242905340_67182239447.jpg', alt: 'Historical cat stories in NYC' },
    { id:  6, src: '/lovable-uploads/catsabouttowntours_1738852061_3562071727242896117_67182239447.jpg', alt: 'Cats About Town tour highlights' },
    { id:  7, src: '/lovable-uploads/catsabouttowntours_1738852061_3562071727184221213_67182239447.jpg', alt: 'NYC cat-themed guided walk' },
    { id:  8, src: '/lovable-uploads/catsabouttowntours_1738852061_3562071727192647726_67182239447.jpg', alt: 'Cat lovers tour in New York' },
    { id:  9, src: '/lovable-uploads/catsabouttowntours_1738852061_3562071727242958002_67182239447.jpg', alt: 'Feline history exploration in NYC' },
    { id: 10, src: '/lovable-uploads/catsabouttowntours_1738852061_3562071727234560792_67182239447.jpg', alt: 'Historical cats of Manhattan tour' },
    { id: 11, src: '/lovable-uploads/catsabouttowntours_1738852061_3562071727234465136_67182239447.jpg', alt: 'NYC cat history walking tour' },
    { id: 12, src: '/lovable-uploads/catsabouttowntours_1740496316_3575864738686739299_67182239447.jpg', alt: 'Cat stories walking tour in New York' },
    { id: 13, src: '/lovable-uploads/catsabouttowntours_1740496316_3575864738686703567_67182239447.jpg', alt: 'NYC historic feline tour' },
    { id: 14, src: '/lovable-uploads/catsabouttowntours_1740496316_3575864738686844447_67182239447.jpg', alt: 'Cats About Town history guide' },
    { id: 15, src: '/lovable-uploads/catsabouttowntours_1740496316_3575864738636465624_67182239447.jpg', alt: 'Cat-themed NYC historical tour' },
    { id: 16, src: '/lovable-uploads/catsabouttowntours_1742834588_3595479581311907013_67182239447.jpg', alt: 'Cat history landmarks in NYC' },
    { id: 17, src: '/lovable-uploads/catsabouttowntours_1742834588_3595479581370764610_67182239447.jpg', alt: 'Feline-focused historical sites in NYC' },
    { id: 18, src: '/lovable-uploads/catsabouttowntours_1742834588_3595479581362387593_67182239447.jpg', alt: 'NYC cat cultural tour' },
    { id: 19, src: '/lovable-uploads/catsabouttowntours_1742834588_3595479581353952387_67182239447.jpg', alt: 'Historical feline locations in NYC' },
    { id: 20, src: '/lovable-uploads/catsabouttowntours_1742834588_3595479581421107868_67182239447.jpg', alt: 'Cat history walking experience' },
    { id: 21, src: '/lovable-uploads/catsabouttowntours_1742834588_3595479581387592630_67182239447.jpg', alt: 'New York cat historical sites' },
    { id: 22, src: '/lovable-uploads/catsabouttowntours_1742834588_3595479581353854572_67182239447.jpg', alt: 'NYC feline historical landmarks' },
    // Image with ID 23 removed
    { id: 24, src: '/lovable-uploads/catsabouttowntours_1744040351_3605594254946378724_67182239447.jpg', alt: 'Cats About Town NYC tour experience' },
    { id: 25, src: '/lovable-uploads/catsabouttowntours_1744040351_3605594254954792928_67182239447.jpg', alt: 'Historic cat stories walking tour' },
  ];

  // UPDATED: Using the new cat photos the user uploaded to GitHub
  const felineFanPhotos = [
    { id: 101, src: '/lovable-uploads/4cf849ae-1f20-11f0-a6d9-0242ac110002-19-hero_image.png', alt: 'Cat photo from @bodegacats' },
    { id: 102, src: '/lovable-uploads/4ccb07aa-1f20-11f0-bef4-0242ac110002-19-hero_image.png', alt: 'Cat photo from @bodegacats' },
    { id: 103, src: '/lovable-uploads/4d80b050-1f20-11f0-b47d-0242ac110002-19-hero_image.png', alt: 'Cat photo from @bodegacats' },
    { id: 104, src: '/lovable-uploads/d42afc9e-cbbc-11ef-87cd-0242ac110002-jpeg-hero_image.jpeg', alt: 'Cat photo from @bodegacats' },
    { id: 105, src: '/lovable-uploads/d420ba7c-cbbc-11ef-8994-0242ac110002-jpeg-hero_image.jpeg', alt: 'Cat photo from @bodegacats' },
    { id: 106, src: '/lovable-uploads/d41ed432-cbbc-11ef-ba07-0242ac110002--hero_image.jpeg', alt: 'Cat photo from @bodegacats' },
    { id: 107, src: '/lovable-uploads/d52027d2-cbbc-11ef-97f1-0242ac110002-JPG-hero_image.jpeg', alt: 'Cat photo from @bodegacats' },
    { id: 108, src: '/lovable-uploads/c7e1bbee-cbbc-11ef-bd75-0242ac110002-jpeg-hero_image.jpeg', alt: 'Cat photo from @bodegacats' },
    { id: 109, src: '/lovable-uploads/c806a4e0-cbbc-11ef-a88f-0242ac110002-JPG-hero_image.jpeg', alt: 'Cat photo from @bodegacats' },
    { id: 110, src: '/lovable-uploads/c83fa7cc-cbbc-11ef-9a3d-0242ac110002-jpg-hero_image.jpeg', alt: 'Cat photo from @bodegacats' },
    { id: 111, src: '/lovable-uploads/c7f851e2-cbbc-11ef-ba07-0242ac110002-jpeg-hero_image.jpeg', alt: 'Cat photo from @bodegacats' },
    { id: 112, src: '/lovable-uploads/c7e8be30-cbbc-11ef-8994-0242ac110002-jpg-hero_image.jpeg', alt: 'Cat photo from @bodegacats' },
    { id: 113, src: '/lovable-uploads/cb6ea53c-cae6-11ef-82b7-0242ac110002-jpg-hero_image (1).jpeg', alt: 'Cat photo from @bodegacats' },
    { id: 114, src: '/lovable-uploads/c8abdca2-cae6-11ef-beeb-0242ac110002-jpg-hero_image.jpeg', alt: 'Cat photo from @bodegacats' },
    { id: 115, src: '/lovable-uploads/8c049d76-cae5-11ef-83d2-0242ac110002-jpg-hero_image.jpeg', alt: 'Cat photo from @bodegacats' },
    { id: 116, src: '/lovable-uploads/e72f91c0-c4bd-11ef-8db9-0242ac110002-jpg-hero_image.jpeg', alt: 'Cat photo from @bodegacats' },
    { id: 117, src: '/lovable-uploads/286a0864-bbc7-11ef-881a-0242ac110002-jpg-hero_image.jpeg', alt: 'Cat photo from @bodegacats' },
    { id: 118, src: '/lovable-uploads/28efe72c-bbc7-11ef-a7cc-0242ac110002-jpg-hero_image.jpeg', alt: 'Cat photo from @bodegacats' },
    { id: 119, src: '/lovable-uploads/28167726-bbc7-11ef-b04f-0242ac110002-jpg-hero_image.jpeg', alt: 'Cat photo from @bodegacats' },
    { id: 120, src: '/lovable-uploads/27aa7544-bbc7-11ef-b093-0242ac110002-jpg-hero_image.jpeg', alt: 'Cat photo from @bodegacats' },
    { id: 121, src: '/lovable-uploads/28754b16-bbc7-11ef-b4ff-0242ac110002-jpg-hero_image.jpeg', alt: 'Cat photo from @bodegacats' }
  ];

  return (
    <div className="min-h-screen pt-20">
      {/* Hero Section - Updated with fixed image path */}
      <Hero 
        title="Cat Gallery" 
        subtitle="Browse photographs from our tours and our community's beloved feline friends"
        backgroundImage="/lovable-uploads/cf69d03b-6e71-43d3-936d-5465eaa5212f.png"
        height="medium"
        imageStyle="darken"
        overlay={false}
      />

      {/* Loading Spinner */}
      {imagesLoading && (
        <div className="flex justify-center items-center h-40 my-8">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-[#800020]"></div>
        </div>
      )}

      {/* Featured on NBC News */}
      <section className="py-16 bg-[#800020]/5 relative">
        <div className="container mx-auto px-6 max-w-4xl">
          <h2 className="text-3xl md:text-4xl font-montserrat font-bold text-center mb-8 text-[#800020]">
            <span className="inline-block mr-2">📺</span> Featured on NBC News
          </h2>
          <p className="text-lg text-center max-w-3xl mx-auto mb-8 text-[#3E2C2F]/90">
            Watch our feature on NBC News, showcasing our unique walking tours of New York's feline history!
          </p>
          
          <div className="aspect-video rounded-xl overflow-hidden shadow-premium mx-auto relative">
            <iframe 
              width="100%" 
              height="100%" 
              src="https://www.youtube.com/embed/Ly8GsIPhVd8?si=7ttXWQ6gp-GaXlFZ" 
              title="NBC News: Cats About Town Tours Feature" 
              frameBorder="0" 
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
              referrerPolicy="strict-origin-when-cross-origin" 
              allowFullScreen
              className="w-full h-full"
            ></iframe>
            {/* Removed the overlay that was blocking the NBC logo */}
          </div>
          
          <div className="flex justify-center mt-8">
            <Link to="/tours" className="bg-[#800020] text-white inline-flex items-center gap-2 px-6 py-3 rounded-lg transition-all duration-300 hover:-translate-y-1 hover:shadow-lg font-medium">
              Book Your Tour Today
            </Link>
          </div>
        </div>
      </section>

      {/* Tour Photos Section */}
      <PhotoGallery 
        images={galleryImages}
        title="Tour Photo Gallery"
        subtitle="Explore our collection of tour photographs showcasing our guides sharing New York's fascinating cat history. Join us to experience these stories firsthand."
        columns={3}
        icon={<Camera className="inline-block mr-2 text-[#800020]" />}
      />

      {/* Feline Fan Photos Section - Updated with ONLY the user's provided images */}
      <PhotoGallery 
        images={felineFanPhotos}
        title="Feline Fan Photos"
        subtitle="Our wonderful customers love to share pictures of their cats with us! Here's a selection of furry companions from the cat lovers who've joined our tours."
        columns={3}
        icon={<Users className="inline-block mr-2 text-[#800020]" />}
      />

      {/* Share Your Cat Photos CTA */}
      <section className="py-16 bg-[#FAF2E8]">
        <div className="container mx-auto px-4 text-center max-w-3xl">
          <h2 className="text-3xl font-montserrat font-bold mb-4 text-[#3E2C2F]">
            Share Your Cat Photos With Us!
          </h2>
          <p className="text-lg mb-8 font-montserrat text-[#3E2C2F]">
            Have an adorable feline friend you'd like to feature in our gallery? 
            We love seeing our tour attendees' cats! Send us your best cat photos 
            and tell us about your tour experience.
          </p>
          <Link to="/contact" className="bg-[#800020] text-white px-6 py-3 rounded font-montserrat font-semibold transition-all duration-300 inline-block shadow-elegant hover:bg-[#800020]/90 hover:scale-105">
            Submit Your Cat Photos
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Gallery;